import nextAction from 'model/actions/utilities/nextAction';
import takeMap from 'model/actions/story/takeMap';

const strangerDrunk = onDone => ({
  title: 'the drunken priest',
  description: [
    'i work at night. the moon is enough to see a pocket by.',
    'a priest tonight. drunk enough to make it easy. no difference to me.',
    'the gun does the asking. he gives up coins and keeps his hand on the pocket.',
    'so there is more in it. i tell him to empty it.'
  ],
  buttons: [nextAction('Reach', () => onDone(attack(onDone)))]
});

const attack = onDone => ({
  title: 'the drunken priest',
  description: [
    'i put my hand in the coat. he goes rigid.',
    'his eyes come up and find my face. whatever he sees there is not me.',
    '"no. no. you are dead"',
    'a drunk making threats over a pocket. nothing in his hands.',
    'then he is on me. hands and teeth.',
    'the gun goes off.'
  ],
  buttons: [nextAction('Shoot', () => onDone(map(onDone)))]
});

const map = onDone => ({
  title: 'the drunken priest',
  description: [
    'an accident. or so i tell myself.',
    'the muzzle flash puts a light on us both. he is looking right at me.',
    'does he know me',
    'too late for it. he folds into the dirt and stays there.',
    'the pocket has a rolled paper in it. that is what it was.',
    'i take what i came for and go.'
  ],
  buttons: [takeMap(onDone)]
});

export default strangerDrunk;
